import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'
import BaseWidgetProvider from '../base/BaseWidgetProvider'
import MachineMaterialWidget from './MachineMaterialWidget'

// Registers the Machine Storage MOS widget (S1/S2/S3/S4/S6/S28/S29/S30 — story #19).
class MachineMaterialWidgetProvider extends BaseWidgetProvider {
  getCode = () => 'MachineMaterialWidget'

  getName = () => 'Machine storage'

  getIcon = () => Inventory2OutlinedIcon

  createWidget = (props) => <MachineMaterialWidget {...props} />

  createPreviewWidget = (props) => <MachineMaterialWidget {...props} preview />

  size = { defaultW: 3, defaultH: 3, minW: 2, minH: 2 }

  getWidgetInfo = (columns, cellHeight) => {
    return { ...super.getWidgetInfo(columns, cellHeight, this.size) }
  }
}

export default MachineMaterialWidgetProvider
